<template>
  <div class="footer-payment-systems">
    <p class="footer-payment-systems__title">Можна оплатити за допомогою:</p>
    <ul class="payment-list">
      <li v-for="paymentSystem in paymentSystems" :key="paymentSystem.name" class="footer-payment-systems__item"><component :is="paymentSystem.icon" /></li>
    </ul>
  </div>
</template>

<script>
export default {
  props: {
    paymentSystems: {
      type: Array,
      required: true,
    },
  }
};
</script>

<style lang="scss" scoped>
.footer-payment-systems {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  background-color: #f6f7fb;
  padding: 25px;

  @media (max-width: 550px) {
    flex-direction: column;
  }

  &__title {
    font-family: inherit;
    font-size: 14px;
    color: #71717A;

    @media (max-width: 550px) {
      margin-bottom: 16px;
    }
  }

  &__item {
    margin: 0 20px;

    @media (max-width: 550px) {
      margin: 16px 20px;
    }
  }
}

.payment-list {
  display: flex;
  align-items: center;

  @media (max-width: 550px) {
    flex-wrap: wrap;
    justify-content: center;
  }
}
</style>
